import { registerSW } from 'virtual:pwa-register'

// 定期检查更新的间隔时间（毫秒）
const CHECK_INTERVAL = 10 * 60 * 1000 // 10分钟

export function registerPWA() {
  if ('serviceWorker' in navigator) {
    console.log('开始注册 PWA Service Worker...')

    // 注册Service Worker
    const updateSW = registerSW({
      // 立即注册
      immediate: true,
      // 当需要刷新时
      onNeedRefresh() {
        console.log('发现新版本，正在更新...')
        // 自动更新，不再询问用户
        updateSW(true)
      },
      onOfflineReady() {
        console.log('应用已可离线使用')
      },
      onRegistered(registration) {
        // 注册成功后，设置定期检查更新
        console.log('Service Worker 注册成功', registration)

        if (registration) {
          // 立即检查一次更新
          registration.update()

          // 设置定期检查更新
          setInterval(() => {
            console.log('定期检查更新...')
            registration.update()
          }, CHECK_INTERVAL)
        } else {
          console.warn('Service Worker 注册成功但没有返回 registration 对象')
        }
      },
      onRegisterError(error) {
        console.error('Service Worker 注册失败:', error)
      }
    })

    // 监听页面可见性变化，当用户切换回应用时检查更新
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        console.log('页面可见，检查更新...')
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration) {
            registration.update()
          } else {
            console.warn('页面可见时未找到已注册的 Service Worker')
          }
        }).catch(error => {
          console.error('获取 Service Worker 注册信息失败:', error)
        })
      }
    })

    // 添加调试信息
    navigator.serviceWorker.ready.then(() => {
      console.log('Service Worker 已准备就绪')
    }).catch(error => {
      console.error('Service Worker ready 事件失败:', error)
    })
  } else {
    console.warn('当前浏览器不支持 Service Worker，PWA 功能将不可用')
  }
}